module.exports = __webpack_public_path__ + "media/images/task-icon-51d1db9ea26a89bccb75cff68a786f8f.svg";